module.exports = __webpack_public_path__ + "img/online-step-6.1216be33.png";